import { render, staticRenderFns } from "./ChengShu.vue?vue&type=template&id=cd2c5fe0&scoped=true"
import script from "./ChengShu.vue?vue&type=script&lang=js"
export * from "./ChengShu.vue?vue&type=script&lang=js"
import style0 from "./ChengShu.vue?vue&type=style&index=0&id=cd2c5fe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2c5fe0",
  null
  
)

export default component.exports